import React from "react";
import { facepaintMediaQueries } from "../shared";
import { colors, Body } from "../../";
import { useLocalization } from "../PatternLibraryProvider";
import * as translations from "./localization";
import { jsx as ___EmotionJSX } from "@emotion/core";
var legendCss = facepaintMediaQueries({
  color: colors.gray[30],
  display: ["block", "block", "none"]
});
export var Legend = function Legend(_ref) {
  var activeStep = _ref.activeStep,
      stepsTotal = _ref.stepsTotal;

  var _useLocalization = useLocalization(translations),
      strings = _useLocalization.strings;

  var legendText = strings.stepOfSteps.replace("[activeStep]", activeStep.toString()).replace("[stepsTotal]", stepsTotal.toString());
  return ___EmotionJSX("div", {
    css: legendCss
  }, ___EmotionJSX(Body, {
    level: "2",
    renderAs: "span"
  }, legendText));
};